const EquipmentCondition = Object.freeze({
  'New': 'New',
  'Used': 'Used',
});

module.exports = { EquipmentCondition };
